<template>
  <div v-loading="loading" class="rj-page-card">
    <div class="rj-page-card__title">
      合同基本信息
    </div>
    <div class="rj-page-card__content">
      <el-form ref="form" :model="form" :rules="rules" class="baseInfoForm">
        <div class="rj-row">
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                订单日期：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.createTime }}
              </div>
            </div>
          </div>
          <!-- <oreder-time v-model="form" /> -->
          <contract-number ref="contractNumber" v-model="form" new-contract="" />
          <supply-unit ref="supplyUnit" v-model="form" @changesupply="changeSupply" @handleChange="handleShippingChange" />
          <ordering-unit v-model="form" />
          <end-customer v-model="form" />
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                订单分类<span class="required">*</span>：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.contractType }}
              </div>
            </div>
          </div>
          <!-- <tax-type v-model="form" required @changeTaxType="changeTaxType" /> -->
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                币种：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.currencyName || '--' }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                净销售额：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="netSales">
                  <el-input v-model="form.netSales" placeholder="请输入净销售额" />
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                结算方式：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="salesType">
                  <el-radio-group v-model="form.salesType" disabled>
                    <el-radio v-for="(type,index) in internationalSalesType" :key="index" :label="type.code">
                      {{ type.name }}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                账期：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.accountPeriod || '--' }}
              </div>
            </div>
          </div>
          <!-- <account-period v-model="form" /> -->
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                付款方式<span class="required">*</span>：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="paymentMethodName">
                  <el-select ref="paymentMethod" v-model="form.paymentMethodName" placeholder="请选择付款方式" style="width:100%;">
                    <el-option v-for="item in paymentMethod" :key="item.label" :label="item.label" :value="item.value" />
                  </el-select>
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                即期/远期：
              </div>
              <div class="rj-baseinfo__item">
                {{ $store.state.enumeration.atAfterSight[form.atAfterSight] || '--' }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                远期时间：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.sightDate }}
              </div>
            </div>
          </div>
          <order-type ref="orderType" v-model="form" required />
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                云桌面授权邮箱：
              </div>
              <div class="rj-baseinfo__item">
                <el-input
                  v-model.trim="form.authorizationEmail"
                  placeholder=""
                />
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                发货方式：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="shipType">
                  <el-radio-group v-model="form.shipType" disabled>
                    <el-radio v-for="(type,index) in shipType" :key="index" :label="type.code">
                      {{ type.name }}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </div>
          </div>
          <!-- <pre-sale v-model="form" required ref="preSale" /> -->
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                售前名称<span class="required">*</span>：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="preSalesName">
                  <el-input v-model="form.preSalesName" placeholder="请输入售前名称" />
                </el-form-item>
              </div>
            </div>
          </div>
          <export-sale ref="exportSale" v-model="form" required />
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                部门：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.departmentName }}
              </div>
            </div>
          </div>
          <region-auto ref="regionAuto" v-model="form" />
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                项目代码(CRM编号)：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="projectCode">
                  <el-input v-model="form.projectCode" placeholder="请输入项目代码" />
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                项目名称：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="projectName">
                  <el-input v-model="form.projectName" placeholder="请输入项目名称" />
                </el-form-item>
              </div>
            </div>
          </div>
          <region-business ref="regionBusiness" v-model="form" />
          <!-- <integrator v-model="form" /> -->

          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                贸易方式：
              </div>
              <div class="rj-baseinfo__item">
                <!-- <el-form-item prop="tradeTerm">
                  <el-select v-model="form.tradeTerm" placeholder="请选择贸易方式" style="width:100%;" ref="paymentMethod">
                    <el-option label="FOB/FCA" value="FOB/FCA" />
                    <el-option label="DAP/DDP" value="DAP/DDP" />
                    <el-option label="CIF/CIP" value="CIF/CIP" />
                  </el-select>
                </el-form-item> -->
                {{ form.tradeTerm }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                计量计点:
              </div>
              <div class="rj-baseinfo__item">
                <span v-if="form.meteringPoint === 1">计量计点</span>
                <span v-if="form.meteringPoint === 2">计量不计点</span>
                <span v-if="form.meteringPoint === 3">不计量不计点</span>
              </div>
            </div>
          </div>
          <market v-if="form.contractType" ref="market" v-model="form" />
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                借条单号：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="borrowingOrderNumber">
                  <el-input v-model="form.borrowingOrderNumber" placeholder="请输入借条单号" />
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                CRM客户编码：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="crmAccountCode">
                  <el-input v-model="form.crmAccountCode" placeholder="请输入CRM客户编码" />
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                二级渠道名称：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.secondChannelName || '--' }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                二级渠道类型：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.secondaryChannelType || '--' }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                目的地：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item>
                  <el-input v-model="form.destination" placeholder="请输入目的地" />
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                运输方式<span class="required">*</span>：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="modeOfShipping">
                  <el-radio-group v-model="form.modeOfShipping" @change="handleShippingChange">
                    <el-radio label="Land">
                      Land
                    </el-radio>
                    <el-radio label="Sea">
                      Sea
                    </el-radio>
                    <el-radio label="Air">
                      Air
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </div>
          </div>
          <export-country ref="exportCountry" v-model="form" required disabled @handleChange="handleShippingChange" />
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                税率：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.formTaxRate ? form.formTaxRate + '%' : '--' }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                已分配金额/比例：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.assignAll }}{{ form.currencyName }} / {{ form.proportion }}%
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                齐套通知打款邮箱：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.setNoticeMail }}
                <!-- <el-form-item prop="setNoticeMail">
                  <el-input v-model.trim="form.setNoticeMail" placeholder="请输入邮箱" />
                  <el-autocomplete
                    class="inline-input"
                    v-model="form.setNoticeMail"
                    :fetch-suggestions="querySearch"
                    placeholder="请输入齐套通知打款邮箱"
                    @select="handleSelect"
                  >
                    <template slot-scope="{ item }">
                      <div class="name">{{ item.setNoticeMail }}</div>
                    </template>
                  </el-autocomplete>
                </el-form-item> -->
              </div>
            </div>
          </div>
          <div v-if="orderUnitDiscount" class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label" style="color:red;">
                上海香港通讯下单折扣：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="communicationOrderDiscount">
                  <el-select v-model="form.communicationOrderDiscount" placeholder="上海香港通讯下单折扣" @change="handleShippingChange">
                    <el-option v-for="(value, key) in interShanghaiHongkongDiscount" :key="key" :label="value" :value="value" />
                  </el-select>
                </el-form-item>
              </div>
            </div>
          </div>
        </div>

        <div class="rj-row">
          <payment-bank ref="bank" v-model="form" />
          <div class="rj-col-1">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                是否使用返利<span class="required">*</span>：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item style="display: inline-block">
                  <el-radio-group v-model="form.isRebate" :disabled="true">
                    <el-radio :label="true">
                      是
                    </el-radio>
                    <el-radio :label="false">
                      否
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
                <template v-if="form.isRebate">
                  <span> 使用返利： {{ form.rebateAmount }} </span>
                  <span style="margin-left: 20px"> 返利可用余额： {{ form.remainderRebateAmount }} {{ form.currencyName }}</span>
                </template>
              </div>
            </div>
          </div>

          <div class="rj-col-1">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                区域商务专员意见：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.regionBusinessCommissionerOpinion }}
              </div>
            </div>
          </div>
          <div class="rj-col-1">
            <el-form-item prop="additionalTerms" label="补充条款:">
              <el-input v-model.trim="form.additionalTerms" type="textarea" :rows="3" placeholder="请输入补充条款内容" maxlength="200" show-word-limit />
            </el-form-item>
          </div>
          <div class="rj-col-1">
            <el-form-item prop="serviceTerms" label="服务条款:" style="margin-top: 10px">
              <el-input v-model.trim="form.serviceTerms" type="textarea" :rows="3" placeholder="请输入服务条款" maxlength="400" show-word-limit />
            </el-form-item>
          </div>
          <div class="rj-col-1">
            <el-form-item prop="receiptArrivalAcceptanceRequirements" label="收货回执及到货验收要求:" style="margin-top: 10px">
              <el-input v-model.trim="form.receiptArrivalAcceptanceRequirements" type="textarea" :rows="3" placeholder="请输入收货回执及到货验收要求" maxlength="200" show-word-limit />
            </el-form-item>
          </div>
          <div class="rj-col-1">
            <el-form-item prop="remarks" label="备注说明:" style="margin-top: 10px">
              <el-input v-model.trim="form.remarks" type="textarea" :rows="3" placeholder="请输入备注说明" maxlength="200" show-word-limit />
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script type="es6">
import { getNoticeSendMailList } from '@/API/index.js';
// import orederTime from '../../../contractCommonInput/orderTime';
import contractNumber from '../../../contractCommonInput/contractNumber';
import supplyUnit from '../../../contractCommonInput/supplyUnit';
import orderingUnit from '../../../contractCommonInput/orderingUnit';
import EndCustomer from '../../../contractCommonInput/EndCustomer';
import baseInfoMixin from '../../createContract/baseInfoMixin';
import { mapState } from 'vuex';
const orderType = () => import('../../../contractCommonInput/orderType');
// const accountPeriod = () => import('../../../contractCommonInput/accountPeriod');
// const preSale = () => import('../../../contractCommonInput/preSale');

const exportSale = () => import('../../../contractCommonInput/exportSale');
const regionAuto = () => import('../../../contractCommonInput/regionAuto');
const regionBusiness = () => import('../../../contractCommonInput/regionBusiness');
// const integrator = () => import('../../../contractCommonInput/integrator');
const market = () => import('../../../contractCommonInput/market');
const paymentBank = () => import('../../../contractCommonInput/paymentBank');
const exportCountry = () => import('../../../contractCommonInput/exportCountry');
// const taxType = () => import('../../../contractCommonInput/taxType');

export default {
  mixins: [baseInfoMixin],
  data () {
    var verifyEmail = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入齐套通知打款邮箱'));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      paymentMethod: [{
        value: '立即',
        label: '立即付款'
      }],
      rules: {
        customerContractNum: [
          { required: true, message: '请输入客户合同编号', trigger: 'blur' }
        ],
        projectName: [
          { required: true, message: '请输入项目名称', trigger: 'blur' }
        ],
        modeOfShipping: [
          { required: true, message: '请选择运输方式', trigger: 'blur' }
        ],
        paymentMethodName: [
          { required: true, message: '请选择付款方式', trigger: 'change' }
        ],
        supplyUnitId: [
          { required: true, message: '请选择供货单位', trigger: 'change' }
        ],
        orderUnitCode: [
          { required: true, message: '请选择订货单位', trigger: 'change' }
        ],
        finalCustomer: [
          { required: true, message: '请选择最终客户', trigger: 'change' }
        ],
        contractType: [
          { required: true, message: '请选择订单分类', trigger: 'change' }
        ],
        currencyId: [
          { required: true, message: '请选择币种', trigger: 'change' }
        ],
        preSalesName: [
          { required: true, message: '请输入售前名称', trigger: 'blur' }
        ],
        salesManCode: [
          { required: true, message: '请选择外销', trigger: 'change' }
        ],
        regionCode: [
          { required: true, message: '请选择区域', trigger: 'change' }
        ],
        saleTypeCode: [
          { required: true, message: '订单类型不能为空', trigger: 'change' }
        ],
        setNoticeMail: [
          { validator: verifyEmail, trigger: 'blur' }
        ],
        soldCountry: [
          { required: true, message: '请选择销往区域', trigger: 'change' }
        ],
        powerCordSpecification: [
          { required: true, message: '请选择电源线规格(2pin)', trigger: 'change' }
        ],
        threePlugPowerCord: [
          { required: true, message: '请选择电源线规格(3pin)', trigger: 'change' }
        ]
      }
    };
  },
  model: {
    prop: 'form',
    event: 'change'
  },
  props: {
    form: {
      type: Object,
      default: () => { return {}; }
    },
    formTaxRate: {
      type: [String, Number],
      default: ''
    }
  },
  watch: {
    formTaxRate (newVal) {
      this.form.formTaxRate = newVal;
    }
  },

  components: {
    contractNumber,
    supplyUnit,
    orderingUnit,
    EndCustomer,
    orderType,
    // accountPeriod,
    exportSale,
    regionAuto,
    regionBusiness,
    market,
    paymentBank,
    exportCountry
  },
  computed: {
    ...mapState({
      moneyType: state => state.enumeration.moneyType,
      internationalSalesType: state => state.enumeration.internationalSalesType,
      // paymentMethod: state => state.enumeration.paymentMethod,
      shipType: state => state.enumeration.shipType,
      isEmbeddedSoftware: state => state.enumeration.isEmbeddedSoftware,
      meteringPoint: state => state.enumeration.meteringPoint,
      interShanghaiHongkongDiscount: state => state.enumeration.interShanghaiHongkongDiscount
    }),
    orderUnitDiscount () {
      let flag = false;
      if (this.form.orderUnit === '星网锐捷（香港）有限公司') {
        flag = true;
      }
      return flag;
    }
  },
  methods: {
    handleShippingChange () {
      this.$emit('shippingChange');
    },
    handleSelect (val) {
      this.form.setNoticeMail = val.setNoticeMail;
    },
    querySearch (queryString, cb) {
      getNoticeSendMailList().then((res) => {
        let json = res.data;
        if (json.status === '200') {
          let results = queryString ? json.data.filter(this.createFilter(queryString)) : json.data;
          cb(results);
        }
      }).catch((res) => {

      });
    },
    createFilter (queryString) {
      return (restaurant) => {
        return (restaurant.setNoticeMail.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    setInitData () {
      this.$refs.supplyUnit.initData();
      if (this.$refs.exportSale) {
        this.$refs.exportSale.initData();
      }
      if (this.$refs.orderType) {
        this.$refs.orderType.initContratOrderType();
      }
      if (this.$refs.integrator) {
        this.$refs.integrator.initData();
      }
      if (this.$refs.final) {
        this.$refs.final.initData();
      }
      if (this.$refs.metrology) {
        this.$refs.metrology.initData();
      }
      if (this.$refs.market) {
        this.$refs.market.initData();
      }
      if (this.$refs.preSale) {
        this.$refs.preSale.initData();
      }
      if (this.$refs.regionAuto) {
        this.$refs.regionAuto.initData();
      }
      if (this.$refs.regionBusiness) {
        this.$refs.regionBusiness.initData();
      }
      if (this.$refs.bank) {
        this.$refs.bank.initData();
      }
      if (this.$refs.exportCountry) {
        this.$refs.exportCountry.initData();
      }
    }
  },
  mounted () {

  }
};
</script>
<style lang="scss">
  .baseInfoForm {
    .el-form-item--mini.el-form-item {
      margin-bottom: 0;
    }
  }
</style>
<style lang="scss">
  .baseInfoForm{
    .el-form-item__error{
      position: relative;
    }
  }
  .required{
    color: red;
    margin-left: 3px;
  }
</style>
